var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "ui zw align-content-center" }, [
        _c("img", {
          staticClass: "ui image",
          attrs: { width: "100px", src: _vm.failImage, alt: "Failed" }
        }),
        _vm._v(" "),
        _c("h1", { staticClass: "header" }, [
          _vm._v(_vm._s(_vm.$t("globals.checkout.failed.title")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ui divider" }),
        _vm._v(" "),
        _c("div", { staticClass: "fail-block" }, [
          _c("p", [
            _vm._v(_vm._s(_vm.$t("globals.checkout.failed.vipps.text")))
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "ui blue button",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.handleRedirect.apply(null, arguments)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("globals.checkout.failed.button_text")))]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.isLocalEnv
        ? [
            _c("loading", {
              attrs: { active: _vm.isLoading, "is-full-page": _vm.fullPage },
              on: {
                "update:active": function($event) {
                  _vm.isLoading = $event
                }
              }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8cb2284e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cb2284e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/payment/vipps/Failed.vue
// module id = dH8n
// module chunks = 1